import ADeeperDive from './ADeeperDive';
import PrescriptionOpioids from './PrescriptionOpioids';
import Jason from './Jason';
import Gail from './Gail';
import HeroinAndIllicitFentanyl from './HeroinAndIllicitFentanyl';
import ProblematicNatureOfIllicitFentanyl from './ProblematicNatureOfIllicitFentanyl';
import OpioidEpidemicIsPersonalJason from './OpioidEpidemicIsPersonalJason';
import OpioidEpidemicIsPersonalCarrie from './OpioidEpidemicIsPersonalCarrie';
import HowOftenDoYou from './HowOftenDoYou';

export default {
  title: 'Elaborate',
  children: [
    ADeeperDive,
    PrescriptionOpioids,
    Jason,
    Gail,
    HeroinAndIllicitFentanyl,
    ProblematicNatureOfIllicitFentanyl,
    OpioidEpidemicIsPersonalJason,
    OpioidEpidemicIsPersonalCarrie,
    HowOftenDoYou
  ]
};



// WEBPACK FOOTER //
// ./src/data/elaborate/index.js